export default __webpack_public_path__ + "static/media/PopularScience.786ac781.svg";